import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-catalogues',
  templateUrl: './catalogues.page.html',
  styleUrls: ['./catalogues.page.scss'],
})
export class CataloguesPage implements OnInit {
  domainId = environment.domainId;
  fieldForms: any;
  savedForm: any;
  id: any;
  isUploading = false;
  catalogueType: string = 'smallImages';
  fieldFormsCarr: any;
  savedFormCarr: any;
  idCarr: any;
  isUploadingCarr = false;
  data = new FormData();
  carrousel = true;
  smallImages = true;
  slidesImagesCatalogue = [];
  buttons = [
    {
      name: 'Catalogo',
      value: 'smallImages',
    },
    {
      name: 'Carrousel',
      value: 'carrousel',
    },
  ];

  constructor(
    private formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private fileSv: FileService,
    private translateSv: TranslateService
  ) {}

  async ngOnInit() {
    try {
      const res = await this.formSv.getForm('catalogues', this.domainId);
      this.fieldForms = res;
      const resCarr = await this.formSv.getForm(
        'bannerCatalogues',
        this.domainId
      ); //Carrousel
      this.fieldFormsCarr = resCarr;
      if (!res.length) this.removeBtn('smallImages');
      if (!resCarr.length) this.removeBtn('carrousel');
    } catch (err) {
      console.error(err);
    }
  }

  removeBtn(name) {
    const index = this.buttons.findIndex((x) => x.value === name);
    this.buttons.splice(index, 1);
  }

  async sendInfo() {
    try {
      this.id && this.data.set('id', String(this.id));
      this.isUploading = true;
      this.data.append(
        'bannerCatalogue',
        JSON.stringify(this.slidesImagesCatalogue)
      );

      const res: any = await this.httpSv.itemAction(
        this.data,
        'catalogues',
        this.id ? 'update' : 'store'
      );
      this.isUploading = false;
      const translate = this.translateSv.instant(
        'CATALOGO_GUARDADO_EXITOSAMENTE'
      );
      await this.uiSv.showToast(translate);
      if (res.status) {
        this.formSv.deleteListProductSrc.next('reloadListProduct');
        this.clearInput();
      }
    } catch (err) {
      if (
        err?.error?.error ===
        'ValidationException: E_VALIDATION_FAILURE: Validation Exception'
      ) {
        const tr = this.translateSv.instant(
          'VERIFICA_QUE_TODOS_LOS_CAMPOS_ESTEN_LLENOS'
        );
        await this.uiSv.presentAlert(tr);
      }
      this.isUploading = false;
    }
  }

  hiddeSegment(ev) {
    const button = document.querySelector(`.${ev}`);
    button.setAttribute('style', 'display: none');
  }

  clearInput() {
    this.id = undefined;
    this.formSv.clearFormSrc.next();
    this.savedForm = undefined;
    this.savedFormCarr = undefined;
    this.slidesImagesCatalogue = [];
    this.data = new FormData();
  }

  async getGallery({ product, action, changeAction }) {
    try {
      this.clearInput();
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction },
        this.id,
        'catalogues',
        'Catalogo',
        this.savedForm
      );
      this.id = id;
      const media = [];
      savedForm.media.map((item) => {
        if (item.id) {
          media.push(item);
          return item;
        }
      });
      savedForm.media = media;
      this.slidesImagesCatalogue = media;
      !this.savedFormCarr && (this.savedFormCarr = { media: [] });
      this.savedFormCarr.media = media;
      this.savedForm = savedForm;
    } catch (err) {
      await this.uiSv.loading?.dismiss();
    }
  }

  deleteImage(file) {
    this.slidesImagesCatalogue = this.slidesImagesCatalogue.filter(
      (x) => x.url !== file
    );
  }

  getData() {
    this.formSv.getDataSrc.next();
    this.sendInfo();
  }

  saveDataProduct(ev: FormData, type?) {
    ev.forEach((item, key) => {
      if (!this.data.get(key)) {
        this.data.set(key, item);
      }
    });
  }
}
